/* eslint-disable react/prop-types */

import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import pathsManifest from '../../../../pathsManifest';
import RatingAndReviewActions from '../../../../flux/actions/RatingAndReviewActions';
import queryUtil from '../../../../utils/queryUtils';
import ReviewProperty from './ReviewProperty';
import { logError } from '@zg-rentals/log-error';

class CommentPage extends React.Component {
  constructor(props) {
    super(props);
  }

  handleBack = () => {
    const { dispatch, routingLocation } = this.props;
    dispatch(push(pathsManifest.propertyRatingAndReviewRatePage + routingLocation.search));
  };

  handleNext = () => {
    // attach rating as a query param in case of a refresh
    const { dispatch, routingLocation, propertyRating, propertyReview, tenantType } = this.props;
    const query = queryUtil.parse(routingLocation.search);

    const body = {
      reviews: [
        {
          type: 'PROPERTY',
          rating: propertyRating,
          comments: propertyReview,
          reviewerType: tenantType || 'FUTURE_RESIDENT',
          source: 'WEB',
        },
      ],
      providerListingId: query.providerListingId,
    };

    dispatch(RatingAndReviewActions.submitReview(body)).catch((err) => {
      logError({
        error: err,
        errorType: 'CommentPage',
        context: {
          location: 'CommentPage#handleNext',
        },
      });
    });

    dispatch(push(pathsManifest.propertyRatingAndReviewManagerPage + routingLocation.search));
  };

  handleReviewChange = (e) => {
    this.props.dispatch(RatingAndReviewActions.editPropertyReview(e.target.value));
  };

  render() {
    const { propertyRating, propertyReview } = this.props;

    return (
      <div className="CommentPage">
        <ReviewProperty
          onReviewChange={this.handleReviewChange}
          propertyReview={propertyReview}
          propertyRating={propertyRating}
          onBack={this.handleBack}
          onNext={this.handleNext}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  propertyReview: state.ratingAndReview.propertyReview,
  propertyRating: state.ratingAndReview.propertyRating,
  routingLocation: state.router.location,
  tenantType: state.ratingAndReview.tenantType,
});

export default connect(mapStateToProps)(CommentPage);
